import User from 'models/core/user/Model.User';
import Model from 'models/Model';
import Claim from '../claim/Model.Claim';
import claimStatusAuditLogListApi from './list/Api.ClaimStatusAuditLog.List';

export default class ClaimStatusAuditLog
  extends Model<Model.IClaimStatusAuditLog>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IClaimStatusAuditLog>
{
  id: number;
  oldStatus?: Model.Enum.ClaimStatusCode;
  newStatus?: Model.Enum.ClaimStatusCode;
  createdAtUtc: string;
  modifiedAtUtc: string;
  claimId: number;
  claim?: Claim;
  createdBy?: User;
  createdById?: number;
  modifiedBy?: User;
  modifiedById?: number;

  constructor(
    data: Partial<Model.IClaimStatusAuditLog> | Utils.FormData<Model.IClaimStatusAuditLog>,
    language?: Locale.Languages
  ) {
    super(
      {
        createdBy: User,
        modifiedBy: User,
        claim: Claim,
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this?.oldStatus,
      info: this?.newStatus,
      subtitle: this.claim?.displayInfo?.title,
    };
  }

  static async list(body?: Api.Core.ClaimStatusAuditLog.List.IRequest) {
    const { payload, ...rest } = await claimStatusAuditLogListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new ClaimStatusAuditLog(it)),
        count: payload.count,
      },
    };
  }
}
